import { React, ReactRouter, useAPI } from 'mcelroy-lib'
import { FormPage, useUserContext, useToast, Link } from 'mcelroy-components'
import { useTurnstile } from '../../util/Turnstile'
import { useQuery } from '../../util/useQuery'

/*
    Log in form
*/
export function LogInPage() {
    const { wrapperRef, turnstile } = useTurnstile()
    const navigate = ReactRouter.useNavigate()
    const toast = useToast()
    const { user } = useUserContext()
    const { run: logIn } = useAPI(`
        mutation logIn($userName: String! $password: String!, $turnstile: String){
            login(userName: $userName password: $password, turnstile: $turnstile){
                id
                firstName
                lastName
            }
        }
    `)

    // The old tapestry way passed multiple server parameters (sp) in the url query
    // The second one (index 1) is the redirect url
    const query = useQuery()
    const redirect = query['sp']?.[1]

    const fields = [
        {
            label: "Email",
            value: "",
            name: "email"
        },
        {
            label: "Password",
            value: "",
            name: "password",
            type: 'password'
        }
    ]

    const buttons = [
        {
            label: 'Log In',
            primary: true,
            onClick: async function (data) {
                try{
                    const token = await turnstile.current.getToken(user?.internal)
                    const response = await logIn({ userName: data.email, password: data.password, turnstile: token })
                    const redirectBase = 'https://sales.mcelroy.com/auth/external.svc?page=Login&sp=S&sp='
                    window.location.href = redirectBase + (redirect ? redirect : 'S' + window.location.href) + '&sp=S'
                }catch(err) {
                    toast.error(err[0]?.message ?? 'Error logging in.  Contact support.')
                    console.log(err)
                    turnstile.current.reset()
                }
            }
        },
        {
            label: 'Create Account',
            onClick: function () {
                navigate("/create")
            }
        }
    ]

    return (
        <div>
            <FormPage title="Log In" fields={fields} buttons={buttons}>
                <div>
                    <Link tabindex="2" to="/reset_password">Forgot Password</Link>
                </div>
                <div style={{marginTop: "20px"}}>
                    By setting up or using an account, you agree to McElroy Manufacturing's <Link tabindex="2" to="/license">License Agreement</Link>.
                </div>
                <div ref={wrapperRef} style={{ marginTop: '20px' }}></div>
            </FormPage>
        </div>
    )
}
